subscription ExportDocumentsStatusSub($exportDocumentId: UUID!) {
  exportDocumentsStatus(exportDocumentId: $exportDocumentId) {
    status
    exportDocument
    {
      entityId
    }
  }
}
